"use strict";

exports.__esModule = true;
exports.UserListView = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Core = require("../../Core");
var _System = require("../../../System");
var _getFilteredUserList = require("../getFilteredUserList");
var _User = require("../../Auth/User");
var _UserListContext = require("../UserListContext");
var _Role = require("../../Role");
var _dec, _dec2, _class, _UserListView;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ListViewWrapper = _styledComponents["default"].div.withConfig({
  displayName: "UserListView__ListViewWrapper",
  componentId: "sc-1dhoz3n-0"
})(["width:100%;height:100%;overflow-y:auto;"]);
var ListItemHeaderWrapper = _styledComponents["default"].div.withConfig({
  displayName: "UserListView__ListItemHeaderWrapper",
  componentId: "sc-1dhoz3n-1"
})(["width:100%;height:100%;display:inline-flex;"]);

/**
 * Renders Plant State Activities List View
 */
var UserListView = exports.UserListView = (_dec = _Role.RoleListContext.withContext, _dec2 = _UserListContext.UserListContext.withContext, _dec(_class = _dec2(_class = (_UserListView = /*#__PURE__*/function (_Component) {
  function UserListView() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.renderSubHeading = function (user) {
      var subheading = user.username || "";
      if (user.profile && user.profile.email) {
        return "( " + subheading + ", " + user.profile.email + " )";
      }
      return "( " + subheading + " )";
    };
    _this.renderUserRoles = function (user) {
      var roles = _this.props.roles;
      var lastIndex = user.roles.length - 1;
      return user.roles.map(function (roleId, index) {
        var comma = index === lastIndex ? "" : ", ";
        return /*#__PURE__*/_react["default"].createElement("span", {
          key: user.id + "-" + roleId
        }, "" + (0, _Role.getRoleName)(roleId, roles) + comma);
      });
    };
    return _this;
  }
  _inheritsLoose(UserListView, _Component);
  var _proto = UserListView.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var users = this.props.users;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, users.fetching && /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null), !users.fetching && /*#__PURE__*/_react["default"].createElement(ListViewWrapper, null, /*#__PURE__*/_react["default"].createElement(_Core.ListView, null, (0, _getFilteredUserList.getFilteredUserList)(users).map(function (user) {
      return /*#__PURE__*/_react["default"].createElement(_Core.ListItemView, {
        key: user.id
      }, /*#__PURE__*/_react["default"].createElement(_Core.ListItemViewLink, {
        to: (0, _System.getScreenURL)("UpdateUser", {
          id: user.id
        })
      }, /*#__PURE__*/_react["default"].createElement(ListItemHeaderWrapper, null, /*#__PURE__*/_react["default"].createElement(_Core.ListItemHeading, {
        level: 4
      }, (0, _User.getUserName)(user))), /*#__PURE__*/_react["default"].createElement(_Core.ListItemDescription, null, _this2.renderSubHeading(user)), /*#__PURE__*/_react["default"].createElement(_Core.ListItemDescription, null, _this2.renderUserRoles(user))));
    }))));
  };
  return UserListView;
}(_react.Component), _UserListView.defaultProps = {
  users: undefined,
  roles: undefined
}, _UserListView)) || _class) || _class);